import { render, staticRenderFns } from "./GroupAddEditDialog.vue?vue&type=template&id=048e70cf"
import script from "./GroupAddEditDialog.vue?vue&type=script&lang=js"
export * from "./GroupAddEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports